<template>
    <account-picker
        v-model:account-no="line.accrualAccountNo"
        :accounts="accounts"
        placeholder="Periodiseringskonto"
        data-cy="accrual-account-input"
    />
</template>

<script setup lang="ts">
import {TransactionEntryLine} from '@/types/transaction/TransactionEntryLine'
import AccountPicker from '@/account-picker/AccountPicker.vue'
import {bookkeepingAccounts} from '@/bookkeeping-account/bookkeepingAccount.service'

const line = defineModel<TransactionEntryLine>({required: true})

const accounts = bookkeepingAccounts.value.filter(account => account.isAccrual)

</script>

<style scoped>

</style>